module.exports = __webpack_public_path__ + "img/chevron-top.d48da897.svg";